import { render } from "./ArchivedReportOverlay.vue?vue&type=template&id=1be9a795"
import script from "./ArchivedReportOverlay.vue?vue&type=script&lang=js"
export * from "./ArchivedReportOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__